import React, { useEffect, useRef, useState } from 'react';
import {AppBar, CssBaseline, Toolbar, Typography, Button,Box, withStyles} from '@material-ui/core';
import {useStyles} from '../../styles/styles';
import { LogoutAction, LoadUserCredential } from '../../redux/actions/AuthActions';

import SimpleMenu from "./Navigation";
import {useDispatch, useSelector} from 'react-redux';
import {useHistory,Link} from 'react-router-dom'; 
import logo from "../../logo.png";
const styles = {
   
    headerSection: {
        paddingTop: "15px",
        paddingBottom: "15px",
        backgroundColor: "#fff",
    },
    roleSection: {
        position: "absolute",
        left: "10px",
        color: "#dddddd",
        fontSize:"12px",
        top:"30px",
        '@media (max-width: 500px)': {
            position: "relative",
            left:"10px",
            top:"0px"
        },
    },
    title: {
        flexGrow: 1,
    },
    link: {
        color: "white",
        textDecoration: "none",
    },
    headerTextSection: {
        color: "#b92034",
        textAlign: "left",
        width: "200px",
        fontWeight: "Bolder",
        fontSize: "20px",
       
        '@media (max-width: 500px)': {
            display: "none"
        },
    },
    LoginLogoutBar: {
        marginRight: "0%",
        color: "#67a8e4",
        fontSize: "16px",
        lineHeight:1,
        textTransform:"capitalize",
        '@media (max-width: 500px)': {
            textAlign:"left"
        },
    },
    profileLink:
    {
        color: "#67a8e4",
        fontSize: "18px",
        textDecoration:"none"
    },
     desktop:{
        display: "inline-block",
         width: "280px",
        alignItems: "center",
        marginRight:"10%",
         position: "absolute",
         right: 0,
      '@media (max-width: 500px)': { 
          marginRight:0,
        display:"none"
    },
        
  },
    mobile:{
        display:"none",
        '@media (max-width: 500px)': {
            display:"block"
        }
       
  },
   floatingBox: {
        position: "relative",
        right: "12.99%",
        textAlign: "right",
        top: "139px"
    },
    floatingBoxRef: {
        color: "#67a8e4"
    }


};
function Header(props) {
    const history = useHistory();
   const {classes} = props;

   const dispatch = useDispatch();
    const profileResponse = useSelector(state => state.userAuth.userDetail);
   const authResponse = useSelector(state=>state.userAuth.authResponse);
   const loginNotifier = useSelector(state=>state.userAuth.loginNotifier);
    const credentials = useSelector(state => state.userAuth.credentials);
    const [profileDetail, setProfileDetail] = useState("");
    const [manualUrl, setManualUrl] = useState("");
    
    
    
   const logOut = () => {
   
       dispatch(LogoutAction(history));
      
       
       
   }
    const profile = () => {


        history.push("/profile");

    }
   const login = () => {
    history.push("/user/login");
}


    const token = sessionStorage.getItem('user-token');
   
    
   

   useEffect(() => {
       if (profileDetail === "" && loginNotifier){
        dispatch(LoadUserCredential(setProfileDetail,setManualUrl))
       }
      
    if(authResponse !== "" && authResponse.success === true){
       
        
        sessionStorage.removeItem('user-token');
        sessionStorage.removeItem('role-users-id');
        setProfileDetail("");
       // history.push("/");    
    } 
    return () => {
     };
   }, [authResponse || credentials == "" || profileDetail==""])





  return (
      <>
    {
        (loginNotifier === true)?
    <div className={classes.root}>

        <CssBaseline />
        <AppBar position="fixed" className={classes.headerSection} style={{ background: '#fff',textAlign:"left" }}>

            <Toolbar>

            <Typography variant="h6" noWrap className={classes.title} style={{ width:"400px",maxWidth:"400px",marginLeft:"10%" }}>
                                 <Link to="/home" className={classes.link}>   <Box
                    component="img"
                            sx={{
                            height: { xs: 45, md: 70 },
                            width:{ xs: 200, md: 400 },
                            maxHeight: { xs: 233, md: 167 },
                            maxWidth: { xs: 200, md: 400 },
                            minWidth:{ xs: 200, md: 400 },
                            }}
                    alt="DOED"
                    src={logo}
                /> </Link>
                       
            </Typography>
            

                              {/* <Typography variant="h6" noWrap className={[classes.title, classes.headerTextSection].join(" ")} style={{ fontSize: "20x", marginLeft: "10%", fontWeight: "bolder", textAlign: "center", transform:'translateX(-50%)' }}>
                                  Online Application System
            </Typography> */}
                            
            {
            (loginNotifier === true)?
                                      <div className={classes.desktop}><Button onClick={profile} className={classes.LoginLogoutBar}>{(profileDetail != "") ? profileDetail.user.name : "Profile"}</Button>
                                          <span className={classes.roleSection}>{(profileDetail != "") ? profileDetail.user.role_user.name : "Role"}</span>
                                       |
                                          <Button onClick={logOut} className={classes.LoginLogoutBar}>Logout</Button> </div> : <div className={classes.desktop}><Button onClick={login} className={classes.LoginLogoutBar}>Login</Button></div>

        }
                            {
                                (loginNotifier === true) ?
                                      <div className={classes.mobile}><Button onClick={profile} className={classes.LoginLogoutBar}>{(profileDetail != "") ? profileDetail.user.name : "Profile"} <br />   </Button><br/>
                                          <span className={classes.roleSection}>{(profileDetail != "") ? profileDetail.user.role_user.name : ""}</span>
                                          <Button onClick={logOut} className={classes.LoginLogoutBar}>Logout</Button> </div> : <div className={classes.mobile}><Button onClick={login} className={classes.LoginLogoutBar}>Login</Button></div>

                            }

            
            </Toolbar>
            

        </AppBar>
                      <div className={classes.floatingBox}> <a href={manualUrl} className={classes.floatingBoxRef} target="_blank">Download User Manual</a></div>  
                      <SimpleMenu />        
                          
        
    </div>:""
        }
          
        </>
  );
}
export default withStyles(styles)(Header);